import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import PhoneCentralConfigsAPI from '../../api/phoneCentralConfigs';

export const state = {
  records: [],
  callLogs: {
    data: [],
    meta: { current_page: 1, per_page: 25, total_count: 0, total_pages: 0 },
  },
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isFetchingCallLogs: false,
  },
};

export const getters = {
  getConfigs(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getConfigById: _state => id => {
    return _state.records.find(record => record.id === Number(id)) || {};
  },
  getCallLogs(_state) {
    return _state.callLogs;
  },
};

export const actions = {
  get: async function getConfigs({ commit }) {
    commit(types.SET_PHONE_CENTRAL_UI_FLAG, { isFetching: true });
    try {
      const response = await PhoneCentralConfigsAPI.get();
      commit(types.SET_PHONE_CENTRAL_CONFIGS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_PHONE_CENTRAL_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createConfig({ commit }, configObj) {
    commit(types.SET_PHONE_CENTRAL_UI_FLAG, { isCreating: true });
    try {
      const response = await PhoneCentralConfigsAPI.create(configObj);
      commit(types.ADD_PHONE_CENTRAL_CONFIG, response.data);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_PHONE_CENTRAL_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateConfig({ commit }, { id, ...updateObj }) {
    commit(types.SET_PHONE_CENTRAL_UI_FLAG, { isUpdating: true });
    try {
      const response = await PhoneCentralConfigsAPI.update(id, updateObj);
      commit(types.EDIT_PHONE_CENTRAL_CONFIG, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_PHONE_CENTRAL_UI_FLAG, { isUpdating: false });
    }
  },

  getCallLogs: async function getCallLogs({ commit }, filters = {}) {
    commit(types.SET_PHONE_CENTRAL_UI_FLAG, { isFetchingCallLogs: true });
    try {
      const response = await PhoneCentralConfigsAPI.getCallLogs(filters);
      commit('SET_PHONE_CENTRAL_CALL_LOGS', response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_PHONE_CENTRAL_UI_FLAG, { isFetchingCallLogs: false });
    }
  },

  delete: async function deleteConfig({ commit }, id) {
    commit(types.SET_PHONE_CENTRAL_UI_FLAG, { isDeleting: true });
    try {
      await PhoneCentralConfigsAPI.delete(id);
      commit(types.DELETE_PHONE_CENTRAL_CONFIG, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_PHONE_CENTRAL_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_PHONE_CENTRAL_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  ['SET_PHONE_CENTRAL_CALL_LOGS'](_state, data) {
    _state.callLogs = data;
  },

  [types.SET_PHONE_CENTRAL_CONFIGS]: MutationHelpers.set,
  [types.ADD_PHONE_CENTRAL_CONFIG]: MutationHelpers.create,
  [types.EDIT_PHONE_CENTRAL_CONFIG]: MutationHelpers.update,
  [types.DELETE_PHONE_CENTRAL_CONFIG]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
